<script lang="ts">
  import Header from "./shared/Header.svelte";
  import Footer from "./shared/footer/Footer.svelte";
  import Container from "./shared/Container.svelte";
  import { pageStore, clientPublicStore } from "../../stores";
  import { Pages } from "../../utils/enums";

  export let shouldBlurBackdrop: boolean;
  export let isHeaderShown: boolean;
  export let footerAdditionalLogo: { img?: string, width: number} | undefined  = undefined;
  export let clientLogoHeader: string | null

  export let onCloseClick: () => void;

  $: isWelcome = $pageStore === Pages.WELCOME;
  $: ui = $clientPublicStore?.ui_settings;
  $: chromeStyle = isWelcome
    ? [
        ui?.background_color && `background-color:${ui.background_color} !important`,
        ui?.background_image_url &&
          `background-image:url(${JSON.stringify(ui.background_image_url)}) !important;background-size:100% auto !important;background-repeat:no-repeat !important`,
        ui?.text_color && `color:${ui.text_color} !important`,
      ]
        .filter(Boolean)
        .join(";") || undefined
    : undefined;
</script>

<div id="cpui" class="crdz-ui">
  <div
    class="crtw-font-['Poppins'] crtw-fixed crtw-z-[1050] crtw-top-0 crtw-left-0 crtw-min-w-screen crtw-w-full
    crtw-min-h-screen crtw-h-full crtw-flex crtw-justify-center crtw-items-center crtw-bg-black/70
    crtw-text-[#121e2b]"
    class:crtw-backdrop-blur-md={shouldBlurBackdrop}
  >
    <div
      class="crtw-bg-white crtw-rounded-lg crtw-relative crtw-w-full crtw-overflow-y-scroll
      crtw-max-w-[380px] crtw-max-h-full sm-tall:crtw-max-h-[650px] sm:crtw-max-w-md"
      style={chromeStyle}
    >
      <Header {onCloseClick} {isHeaderShown} {clientLogoHeader}/>
      <Container class="crtw-py-9 sm:crtw-pt-[30px] crtw-px-[22px]">
        <div
          class="crtw-flex crtw-flex-col crtw-items-center crtw-justify-center crtw-rounded
           crtw-min-h-[155px] crtw-gap-6"
          class:crtw-bg-white={!isWelcome}
        >
          <slot />
        </div>
        <Footer
          additionalLogo={footerAdditionalLogo}
          linkColor={isWelcome ? ui?.link_color : undefined}
          hideCredenzaLogo={isWelcome}
        />
      </Container>
    </div>
  </div>
</div>

<style>
  :global(body) {
    --w3m-z-index: 1000001;
  }
</style>
